function initialState() {
  return {
    people: [],
  };
}

let state = initialState();

export { initialState, state };
